import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3451">
      <Navbar data-id="element-3452" />
      <main data-id="element-3453">
        <ConsularAffairs data-id="element-3454" />
      </main>
      <Footer data-id="element-3455" />
      <FeedbackPopup data-id="element-3456" />
    </div>;
}